import { render, staticRenderFns } from "./FlyerBlock.vue?vue&type=template&id=5ce79c16&"
import script from "./FlyerBlock.vue?vue&type=script&lang=js&"
export * from "./FlyerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports